import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Flex, ResponsiveSVG } from 'ui/acro'
import Lock from '../../../assets/images/lock.svg'
import {
  hasAloAccessMembership,
  isAloAccessType
} from '../../components_v1/SchemaSectionRenderer/common/components/constants'
import {
  premium_unlock_click_event,
  verify_account_initiated_event
} from 'gtm/pushEvents'

const Container = styled.div`
  display: none;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  border-radius: 4px;
  border: ${({ variant }) =>
    isAloAccessType(variant) ? '1px solid #d6c7b3' : '1px solid #3A3A39'};
  background: ${({ variant }) =>
    isAloAccessType(variant) ? '#f4f1ec' : '#CDCDCD'};
  padding: 12px 16px;
  margin-top: 8px;

  @media (max-width: 768px) {
    display: flex;
  }
`

const BudgeContainer = styled.div``

const TextContainer = styled.div`
  color: #000;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
`

const ContainerSvg = styled(Flex)`
  background-color: ${({ variant }) =>
    isAloAccessType(variant)
      ? 'rgba(214, 199, 179, 1)'
      : 'rgba(58, 58, 57, 1)'};
  color: ${({ variant }) => (isAloAccessType(variant) ? '#000' : '#FFF')};
  padding: 4px 8px;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
  font-family: 'Proxima-Nova';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  border-radius: 12px;
  display: inline-flex;

  svg {
    fill: ${({ variant }) => (isAloAccessType(variant) ? '#000' : '#fff')};
    width: 24px;
    height: 24px;
  }
`

const Link = styled('a')({
  color: '#000',
  textDecoration: 'underline',
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '24px',
  letterSpacing: '0.352px',
  '&:hover, &:active, &:visited': {
    color: '#000'
  }
})

const SignupContainer = styled.div``

const MobileUserAccessBadge = ({ classDetails, user }) => {
  const availabilityGating = classDetails?.availabilityGating
  const membershipTier = user?.membershipTier

  const REDIRECT_URL = useMemo(() => {
    if (user) {
      return `/settings/membership?redirect_to=${window.location.pathname}`
    }
    return `/signin?redirect_to=${encodeURIComponent(window.location.pathname)}`
  }, [user, membershipTier])

  const handleClick = () => {
    if (user) {
      return premium_unlock_click_event('class')
    }
    verify_account_initiated_event('class_details_visitor')
  }
  if (!availabilityGating) return null

  return (
    <Container variant={availabilityGating}>
      <BudgeContainer>
        <ContainerSvg variant={availabilityGating}>
          <ResponsiveSVG SVG={Lock} width='14px' height='14px' />
          {isAloAccessType(availabilityGating) ? 'ALO Access' : 'Premium'}
        </ContainerSvg>
      </BudgeContainer>
      <TextContainer>
        {isAloAccessType(availabilityGating)
          ? user
            ? 'Free AWC access is powered by the ALO Access loyalty program. Visit Manage Membership and join or link to unlock the full AWC library. '
            : 'Unlock access to the full content library for free by signing up or sign in using ALO account.'
          : hasAloAccessMembership(membershipTier)
          ? 'Unlock this class by upgrading to premium with a monthly subscription plan.'
          : 'Join now at no cost and upgrade later to unlock this class with premium.'}
      </TextContainer>
      <SignupContainer>
        <Link
          href={REDIRECT_URL}
          className='unstyled'
          id='united-forgot-mpnumber'
          onClick={handleClick}
        >
          {user ? 'Manage Membership' : 'JOIN NOW'}
        </Link>
      </SignupContainer>
    </Container>
  )
}

export default MobileUserAccessBadge
